<template>
  <div class="sideButton">
    <ul>
<li><router-link to="/customer/contact" v-on:mouseenter.native="openSubmenu" v-on:mouseleave.native="closeSubmenu" ref="contact"><form-textarea/>フォーム</router-link></li>
<li><a href="mailto:toyoshima.precision.industry@gmail.com?subject=お問合せ" v-on:mouseenter="openSubmenu" v-on:mouseleave="closeSubmenu" ref="mail"><Email/>メール</a></li>
<li><a href="tel:0334918624" v-on:mouseenter="openSubmenu" v-on:mouseleave="closeSubmenu" ref="tel"><cellphone-wireless/>電話</a></li>
    </ul>
  </div>
</template>

<script>
/*スクロール状態で背景色を変える処理*/
/*プルダウン表示をbootstrapからvue.jsに*/
import FormTextarea from 'vue-material-design-icons/FormTextarea.vue'
import Email from 'vue-material-design-icons/Email.vue'
import CellphoneWireless from 'vue-material-design-icons/CellphoneWireless.vue'

export default {
  name:'ContactMenu',
  components:{ FormTextarea, Email, CellphoneWireless, },
  computed: {
  },
  mounted: function() {
  },
  methods: {
    openSubmenu:function(event)  {
      event.target.classList.add('openSubmenu')
    },
    closeSubmenu:function(event)  {
      event.target.classList.remove('openSubmenu')
    },
    parentOpenSubmenu:function(target)  {
      if(this.$refs[target].$el === undefined ) {
      //対象オブジェクトがVue componentでない場合
        this.$refs[target].classList.add('openSubmenu')
      } else {
      //対象オブジェクトがVue componentの場合
        this.$refs[target].$el.classList.add('openSubmenu')
      }
    },
    parentCloseSubmenu:function()  {
      this.$refs['contact'].$el.classList.remove('openSubmenu')
      this.$refs['mail'].classList.remove('openSubmenu')
      this.$refs['tel'].classList.remove('openSubmenu')
    },
  }
}
</script>

<style>
</style>